import { render } from "./RequisitosViewComponent.vue?vue&type=template&id=caa7c220&scoped=true"
import script from "./RequisitosViewComponent.vue?vue&type=script&lang=js"
export * from "./RequisitosViewComponent.vue?vue&type=script&lang=js"

import "./RequisitosViewComponent.vue?vue&type=style&index=0&id=caa7c220&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa7c220"]])

export default __exports__